import React from "react";
import "./ChemicalResultsPDF.scss";
import { useTranslation } from "react-i18next";
import logo from "../../../../../assets/images/Honeywell.jpg";
import moment from 'moment';
import { useSelector } from "react-redux";
import { kclRootState } from "../../../../../store/gloveSelectorStore";

const ChemicalResultsPDF = (props) => {
  const { t } = useTranslation();
  const typeOfChemicalResultsSelected = useSelector((state: kclRootState) => state?.glovesSelector?.calculator?.typeOfChemicalResultsSelected || []);
  const FacetList =
    [
      { label: t("filterFacets.Available_Chempro"), column: 'available_on_chempro' },
      { label: t("filterFacets.Brand"), column: 'brand' },
      { label: t("filterFacets.Protection_Type"), column: 'protection_type' },
      { label: t("filterFacets.Size"), column: 'size' },
      { label: t("filterFacets.Length"), column: 'length' },
      { label: t("filterFacets.Thickness"), column: 'thickness' },
      { label: t("filterFacets.Color"), column: 'color' },
      { label: t("filterFacets.Gauge"), column: 'gauge' },
      { label: t("filterFacets.Grip"), column: 'grip' },
      { label: t("filterFacets.Coating_Type"), column: 'coating_type' },
      { label: t("filterFacets.Materials"), column: 'material' },
      { label: t("filterFacets.Coating_Material"), column: 'coating_material' },
      { label: t("filterFacets.Lining_Material"), column: 'lining_material' },
      { label: t("filterFacets.Silicon_Free"), column: 'silicon_free', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Clean_Room"), column: 'clean_room_capability', group: 'specifications', groupTitle: t("filterFacets.Specifications")  },
      { label: t("filterFacets.Touch_Screen"), column: 'touch_screen_capacitive', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Velourised"), column: 'velourised', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Includes_Liner"), column: 'lncludes_liner', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Washable"), column: 'washable', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Latex_Free"), column: 'latex_free', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Microorganism"), column: 'microorganism_protection', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Virus_Protection"), column: 'virus_protection', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Medical_Devices"), column: 'medical_devices', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Antistatics"), column: 'antistatics_en_16350', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Food_Certifications"), column: 'food_certifications', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Type_Welding"), column: 'type_en_12477_welding', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.OEKO_TEX"), column: 'oeko_tex_100_class', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Tested_421"), column: 'tested_for_421', group: 'specifications', groupTitle: t("filterFacets.Specifications") },
      { label: t("filterFacets.Test_Chemical"), column: 'test_chemicals', group: 'en374', groupTitle: t("filterFacets.En374"), multiselect: true },
      { label: t("filterFacets.Type"), column: 'type', group: 'en374', groupTitle: t("filterFacets.En374"), multiselect: true },
      { label: t("filterFacets.AQL"), column: 'aql_penetration_resistance', group: 'en374', groupTitle: t("filterFacets.En374"), multiselect: true },
      { label: t("filterFacets.Abrasion"), column: 'abrasion_resistance', group: 'en388', groupTitle: t("filterFacets.En388"), multiselect: true },
      { label: t("filterFacets.Cut_Protection_Level"), column: 'cut_protection_level', group: 'en388', groupTitle: t("filterFacets.En388"), multiselect: true },
      { label: t("filterFacets.Tear_Resistance"), column: 'tear_resistance', group: 'en388', groupTitle: t("filterFacets.En388"), multiselect: true },
      { label: t("filterFacets.Puncture_Resistance"), column: 'puncture_resistance', group: 'en388', groupTitle: t("filterFacets.En388"), multiselect: true },
      { label: t("filterFacets.Cut_Resistance"), column: 'cut_resistance_iso_13997_ansi_isea', group: 'en388', groupTitle: t("filterFacets.En388"), multiselect: true },
      { label: t("filterFacets.Impact_Protection"), column: 'impact_protection', group: 'en388', groupTitle: t("filterFacets.En388"), multiselect: false },
      { label: t("filterFacets.Limited_Flame"), column: 'limited_flame_spread', group: 'en407', groupTitle: t("filterFacets.En407"), multiselect: true  },
      { label: t("filterFacets.Contect_Heat"), column: 'contact_heat', group: 'en407', groupTitle: t("filterFacets.En407"), multiselect: true  },
      { label: t("filterFacets.Convective_Heat"), column: 'convective_heat', group: 'en407', groupTitle: t("filterFacets.En407"), multiselect: true  },
      { label: t("filterFacets.Radiant_Heat"), column: 'radiant_heat', group: 'en407', groupTitle: t("filterFacets.En407"), multiselect: true  },
      { label: t("filterFacets.Molten_Metal_Small"), column: 'molten_metal_small_splashes', group: 'en407', groupTitle: t("filterFacets.En407"), multiselect: true  },
      { label: t("filterFacets.Molten_Metal"), column: 'molten_metal_large_quantities', group: 'en407', groupTitle: t("filterFacets.En407"), multiselect: true  },
      { label: t("filterFacets.Convective_Cold"), column: 'convective_cold', group: 'en511', groupTitle: t("filterFacets.En511"), multiselect: true  },
      { label: t("filterFacets.Contact_Cold"), column: 'contact_cold', group: 'en511', groupTitle: t("filterFacets.En511"), multiselect: true  },
      { label: t("filterFacets.Water_Penetration"), column: 'water_penetration', group: 'en511', groupTitle: t("filterFacets.En511"), multiselect: true  },
      { label: t("filterFacets.Product_Name"), column: 'product_name' },
      { label: t("filterFacets.Style_No"), column: 'style_no' }

    ];

  const date = moment().format('DD-MM-YYYY');
  const time = moment().format('HH:mm:ss');
  return (
    <div className="gloves-results-wrapper">
      <div id="gloves-resultsPdf-page1" className="gloves-resultsPdf-page1">
        <h1>{t("kclGloves.Gloves_Selector")}</h1>
        <div className="facetPDF">
          {props?.data?.length > 0 && (
            <>
              <div className="page-title">{t("kclGloves.Filters_Applied")}</div>
              {props?.data?.map((filterBody, key) => {
                const filterKey = FacetList?.filter((item) => [`${Object.keys(filterBody)}`]?.toString() === item?.column);
                const filterValue = FacetList?.filter((value) => [`${Object.keys(filterBody)}`]?.toString() === value?.column);
                return (
                  <div key={filterKey?.map((item) => item?.groupTitle ? item?.groupTitle : key)?.[0]}>
                    <div className="filter-panel">
                      <div className="panel-heading" >
                        {filterValue?.map((item) => item?.groupTitle ? item?.groupTitle : item?.label)}
                      </div>
                      <div className="panel-body">
                        {filterBody?.[`${Object.keys(filterBody)}`]?.map((item, key) => {
                          return (
                            <div key={key} className="item-select" id="item-select-size-6">
                              <input id="input-item-select-size-6" name="size" type="checkbox" checked />
                              <label>
                                {filterValue?.map((value) =>
                                  value?.groupTitle ? (value?.multiselect ? value?.label + " - " + item : value?.label) : item)}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
        <div className="resultsPDF">
          <div className="pdf-word-spacing">
            <div className="page-title">{t("kclGloves.Explanation")}</div>
            <div className="row bor-bottom table-content">
              <div className="modal-subtitle">{t("kclGloves.Permeation")}</div>
              <div className="col-sm-6 col-12 p-lg-0">
                <ul>
                  <li>
                    <span>{t("kclGloves.Level")} A:</span> 1 {t("kclGloves.Mins")} &lt;= x &lt; 5 {t("kclGloves.Mins")}
                  </li>
                  <li>
                    <span>{t("kclGloves.Level")} B:</span> 6 {t("kclGloves.Mins")} &lt;= x &lt; 9 {t("kclGloves.Mins")}
                  </li>
                  <li>
                    <span>{t("kclGloves.Level")} 1:</span> 10 {t("kclGloves.Mins")} &lt;= x &lt; 30 {t("kclGloves.Mins")}
                  </li>
                  <li>
                    <span>{t("kclGloves.Level")} 2:</span> 30 {t("kclGloves.Mins")} &lt;= x &lt; 60 {t("kclGloves.Mins")}
                  </li>
                </ul>
              </div>
              <div className="col-sm-6 col-12">
                <ul>
                  <li>
                    <span>{t("kclGloves.Level")} 3:</span> 60 {t("kclGloves.Mins")} &lt;= x &lt; 120 {t("kclGloves.Mins")}
                  </li>
                  <li>
                    <span>{t("kclGloves.Level")} 4:</span> 120 {t("kclGloves.Mins")} &lt;= x &lt; 240 {t("kclGloves.Mins")}
                  </li>
                  <li>
                    <span>{t("kclGloves.Level")} 5:</span> 240 {t("kclGloves.Mins")} &lt;= x &lt; 480 {t("kclGloves.Mins")}
                  </li>
                  <li>
                    <span>{t("kclGloves.Level")} 6:</span> &gt;= 480 {t("kclGloves.Mins")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="modal-subtitle">{t("kclGloves.Swelling")} </div>
              <p>{t("kclGloves.Swelling_Explain")} </p>
            </div>
            <div className="row">
              <div className="modal-subtitle">{t("kclGloves.Swelling_Resistance")}</div>
              <div className="col-sm-6 col-12 p-lg-0">
                <ul>
                    <li>+: {t("kclGloves.Resistant")} <span className='less-greater-symbol'>&lt;</span> {t("kclGloves.Resistant_Percent")}</li>
                    <li>-: <span className="ml-05">{t("kclGloves.Non_Resistant")}</span> <span className='less-greater-symbol'>&gt;</span> {t("kclGloves.Non_Resistant_Percent")}</li>
                </ul>
              </div>
              <div className="col-sm-6 col-12">
                <ul>
                  <li>0: {t("kclGloves.Partial_Resistatn")} <span className='less-than-symbol'>&lt;</span> {t("kclGloves.Partial_Resistatn_Percent")}</li>
                  <li>Z: {t("kclGloves.Decomposition")}</li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="modal-subtitle">{t("kclGloves.Penetration")}</div>
              <div className="col-sm-6 col-12 p-lg-0">
                <ul>
                  <li><span>{t("kclGloves.Level")} 1:</span> {t("kclGloves.AQL4")}</li>
                  <li><span>{t("kclGloves.Level")} 3:</span> {t("kclGloves.AQL0")}</li>
                </ul>
              </div>
              <div className="col-sm-6 col-12">
                <ul>
                  <li><span>{t("kclGloves.Level")} 2:</span> {t("kclGloves.AQL1")}</li>
                </ul>
              </div>
              <div className="col-sm-12 col-12 ml-10">
                <p className="pl-15"><span>{t("kclGloves.Level")} 3 =</span> {t("kclGloves.ControlExplain")}</p>
              </div>
            </div>
          </div>
          <div className="page-title">{t("kclGloves.Showing_Permeation_Minutes")} {typeOfChemicalResultsSelected === "Levels" ? t("kclGloves.Levels") : t("kclGloves.Minutes")}</div>
          <table className="resultsTable" id="results-tab"></table>
        </div>
        <div id="pdfFooter" className="pdf-footer">
          <div className="contact-info">
            <p className="info-text">
            {t("kclGloves.Date_and_Time")} {date} {time.toLocaleString()}
            </p>
            <p className="info-text"><strong>KCL GmbH</strong>, Am Kreuzacker 9, D-36124 Eichenzell / Welkers</p>
            <p className="info-text"> {t("kclGloves.Contact")} <a href="mailto:kcl-chempro@kcl.de">kcl-chempro@kcl.de</a></p>
          </div>
          <div className="honeywell-logo">
            <img className="logo-footer" src={logo} alt="Honeywell Logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChemicalResultsPDF;
